import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Button, Form, Row, Col, Modal, Badge } from "react-bootstrap";
import { Paper, TextField, Grid, Card, CardMedia, CardContent, Chip, Typography, makeStyles, useMediaQuery } from '@material-ui/core';
import * as Admin from "../../../store/ducks/admin.duck";
import * as Reference from "../../../store/ducks/reference.duck";
import { ToastContainer, Flip } from "react-toastify";
import Interweave from 'interweave';
import Masonry from 'react-masonry-css';
import "react-toastify/dist/ReactToastify.css";
import 'bootstrap/dist/css/bootstrap.min.css'
import '../../../../_metronic/_assets/css/app.css';
import '../../../../_metronic/_assets/css/app2.css';

const useStyles = makeStyles((theme) => ({
  root: {
    // minWidth: 200,
    // maxWidth: 200,
  },
  media: {
    height: 200,
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

// Blob setup for psychologist photos 
const containerName = `psychologists`;
const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME || ""; 

export default function ProviderList() {
    
  const dispatch = useDispatch()

  const isMobile = useMediaQuery('(max-width: 760px)');
  // const role = useSelector(state =>  state.auth.roleDesc)
  const [searchList, setSearchList] = useState();
  // const [expanded, setExpanded] = useState(0);
  const matching = useSelector(state => state.admin.Matching)
  const [previousMatching,setPreviousMatching] = useState()
  const [searchType, setSearchType] = useState('Psychologist');
  const [showProviderBio,setShowProviderBio] = useState(false)
  const [providerBioFullName,setProviderBioFullName] = useState()
  const [providerBioBio,setProviderBioBio] = useState()

  
  useEffect( () => { dispatch(Reference.actions.fetchConstants()) }, [dispatch] )
  useEffect( () => { dispatch(Reference.actions.fetchSundayThisWeek()) }, [dispatch] )
  useEffect( () => { dispatch(Reference.actions.fetchAreasOfInterest({providerType:'ALL', centralisedservice: true})) }, [dispatch] )
  useEffect( () => { dispatch(Admin.actions.fetchMatching({ providertype: searchType, invite : false, availabilitytype : 'CentralisedService'  })) }, [dispatch,searchType] )
  
  useEffect( () => { 
    if (matching !== previousMatching)
    {
      setSearchList(matching)
      setPreviousMatching(matching)
    }
  },[matching,previousMatching])

  const moreProviderBio = (fullName, bio) => {
    // console.log('Read More Clicked')
    setProviderBioFullName(fullName)
    setProviderBioBio(bio)
    setShowProviderBio(true)
  }

  const areasOfInterest = useSelector(state =>  state.reference.AreasOfInterest)
  const [searchName, setSearchName] = useState('');
  const [searchAOI, setSearchAOI] = useState();
    
  // const [currentPsychologist, setcurrentPsychologist] = useState();
    
  const searchPsychologist = (p) => {
    if (  true
          // if there is AOI selections, then return if number of matches in psychologist equals the number of options in the selection
          && ( !searchAOI || (searchAOI && searchAOI.length === 0) || (searchAOI && searchAOI.filter(( {issue} ) => p.areasOfInterest.includes(issue)).length === searchAOI.length) )
          // search fullname for search string
          && (p.fullname.toUpperCase().indexOf(searchName.toUpperCase()) > -1 || searchName === '')
    )
    {
      return p
    }
  }
  
  var filteredPsychologists = searchList ? searchList.filter(p => searchPsychologist(p)) : []

  const handleSearchTypeChange = (event) => {
    // Set State 
    setSearchType(event.target.value)
    // Call for new data 
    dispatch(Admin.actions.fetchMatching( { providertype : searchType, invite : true, availabilitytype : 'CentralisedService' }))
    setPreviousMatching()
  }

  const classes = useStyles();

  return (
    <>
     {/* <Button variant="secondary" size="sm" style={{ color: "black", fontWeight: 500, border: 0, background: "#eee" }} onClick={() => loadAppointment()}>
        Book 
     </Button> */}
      <h4>
        Search Available Providers
      </h4>
      <Paper style={{ padding: 15, backgroundColor: "rgb(245,245,245)" }}> 
        <Grid container spacing={3}>
          <Grid item md={3} style={{ height: isMobile ? 270 : 750, backgroundColor: "rgb(245,245,245)", paddingLeft: 10, paddingTop: 10 }}>
            {/* Psychologist search form */}
            <Row>
              <Col md="12">
                <Form.Group >
                  <Form.Label>Search</Form.Label>
                  <Form.Control type="text" name="searchName" value={searchName} onChange={(event) => setSearchName(event.target.value)} autoComplete='new-password' />
                </Form.Group>
              </Col>
              <Col md="12">
                <Form.Group >
                  <Form.Label>Provider Type</Form.Label>
                  <Form.Control id="searchType" as="select" value={searchType} onChange={handleSearchTypeChange}  >
                      <option value='Psychologist'>Psychologist</option>
                      <option value='Psychiatrist'>Psychiatrist</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md="12">
                <Form.Group >
                  <Form.Label>Area of Interest</Form.Label>
                  <Autocomplete
                    id="searchAOI"
                    variant="outlined"
                    multiple
                    options={areasOfInterest}
                    getOptionLabel={(option) => option.issue }
                    value={searchAOI}
                    onChange={(event, newValue) => setSearchAOI(newValue)}
                    style={{ fullWidth: true, display: 'flex', wrap: 'nowrap', backgroundColor: "white", }}
                    renderInput={(params) => 
                    <TextField 
                        {...params} 
                        type="text"
                        variant="outlined"
                        margin="dense"
                        name="AOISelector"
                        style={{backgroundColor: "", margin: 0, padding: 0}}
                        inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password'}}
                    />}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Grid>
          <Grid item md={9} style={{ height: 710, width: "100%", overflowY: "scroll", paddingLeft: 20, backgroundColor: "rgb(255,255,255)" }}>
            <Masonry
              breakpointCols={isMobile ? 1 : 3}
              className="my-masonry-grid"
              columnClassName="my-masonry-grid_column">
              {filteredPsychologists.map((row, index) => {
                return (
                  <Card className={classes.root} variant="outlined" key={index}>
                    <CardMedia
                      className={classes.media}
                      image={`https://${storageAccountName}.blob.core.windows.net/${containerName}/${row.imageURL}`}
                      title="Psychologist"
                    />
                    <CardContent>
                      <Grid container justifyContent="space-between">
                        <>
                          <Grid item sm={12}>
                            <Typography variant="h5" component="h3">
                            {row.fullname} {`(Next available: ${row.nextAvailable})`}
                            </Typography>
                            <Typography variant="subtitle2">
                              {row.appointmentType === 'BOTH' ? 'Appointments are via Video or Phone call' : row.appointmentType === 'PHONE' ? 'Appointments are via Phone call' : 'Appointments are via Video call'}
                            </Typography>
                            <Typography variant="subtitle1" >
                              {row.providerdescription}
                            </Typography>
                          </Grid>
                          <Grid container style={{ marginBottom: 15, marginTop: 10 }}>
                            {row.areasOfInterest.map((row) => {return (<Chip size="small" key={row} variant="outlined" label={row} style={{ margin: 2 }} />)})}
                          </Grid>
                          <Typography className={classes.pos} color="textSecondary">
                            <br />
                          </Typography>
                          <Grid container>
                            <Typography variant="body2" component="p">
                              <Interweave content={row.bio.substring(0,700)} />
                              {row.bio.length > 700 ?
                                <>
                                  ...
                                  <Badge variant="secondary" onClick={()=>moreProviderBio(row.fullname, row.bio)} style={{ marginRight: 5, cursor: 'pointer' }}>
                                    more
                                  </Badge>
                                </>
                              :
                                null
                              }
                            </Typography>
                          </Grid>
                        </>
                          
                      </Grid>
                    </CardContent>
                  </Card>
                )
              })
            }
          </Masonry>
          </Grid>
        </Grid>
      </Paper>


      <Modal show={showProviderBio} onHide={()=>setShowProviderBio(false)} dialogClassName="invite-modal" >
        <Modal.Header closeButton className="invite-modal">
          <Modal.Title>{providerBioFullName}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="invite-modal" style={{ backgroundColor: 'rgb(245,245,245)' }}>
          <Grid container >
            <Typography variant="body2" component="p">
              <Interweave content={providerBioBio} />
            </Typography>
          </Grid>
        </Modal.Body>
        <Modal.Footer className="invite-modal">
          <Button variant="secondary" onClick={() => setShowProviderBio(false)} className="lightButtonOutlinedLarge">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
   
      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />      
    </>
  )  
}

